import { type FunctionalComponent, h } from '@stencil/core';
import type { ConversationalSearchProductHierarchy, ConversationalSearchProductSuggestions } from '../../../conversational-search-types/conversational-search-types.type';
import { ConversationalSearchMessagesSuggestionsCard } from './suggestions-card/suggestions-card';
import type { labelProviderInterface } from '../../../../../LabelProviderInterface';
import { ConversationalSearchDeatilsHeader } from '../../../conversational-search-partials/details-header/details-header';

export interface IConversationalSearchMessagesSuggestions {
  hierarchy: ConversationalSearchProductHierarchy;
  suggestions: ConversationalSearchProductSuggestions[];
  labelProvider: labelProviderInterface;
  query: string;
  country: string;
  language: string;
  isBannerVariant?: boolean;
}

export const ConversationalSearchMessagesSuggestions: FunctionalComponent<
  IConversationalSearchMessagesSuggestions
> = (props) => {
    const { hierarchy, suggestions, labelProvider, query } = props;
    const isSingleResult = suggestions?.length === 1;
    const isBannerVariant = props.isBannerVariant && !isSingleResult;
    const headerTextSingle = props.labelProvider(
      'conversational.search.suggestions.header.single',
      'Possible product'
    );

    const headerTextMultiple = props.labelProvider(
      'conversational.search.suggestions.header.multiple',
      'Possible products'
    );

    const headerText = isSingleResult ? headerTextSingle : headerTextMultiple;
    const parentTitle = hierarchy?.title;
    const parentSummary = hierarchy?.summary;
    const hasSingleCommVisibleStatusKey = suggestions?.filter((element) => element?.commStatus?.key !== 'COMMERCIALIZED').length === 1;

    return (
      <div class="conversational-search-messages-suggestions">
        <section class='conversational-search-messages-suggestions-header'>
          <div class={{'conversational-search-messages-suggestions-header__title': Boolean(parentTitle)}}>
            <ConversationalSearchDeatilsHeader
              title={parentTitle}
              query={props.query}
              size="large"
              tag="h2"
            />
          </div>
          <div class={{'conversational-search-messages-suggestions-header__summary': Boolean(parentSummary)}}>
            <uiaas-search-conversational-search-expandable-text
              text={parentSummary}
              query={props.query}
              labelProvider={(e, f) => labelProvider(e, f)}
              isBannerVariant={props.isBannerVariant}
            />
          </div>
          {hierarchy || !props.isBannerVariant ? <ConversationalSearchDeatilsHeader
            title={headerText}
            badgeText={suggestions?.length}
            isBannerVariant={props.isBannerVariant}
            query={props.query}
            isParentData={true}
            category={hierarchy?.categoryL2}
            categoryLocalized={hierarchy?.categoryL2Translation}
            url={hierarchy?.openUrl}
            size="large"
            tag="h2"
          /> : ''}
        </section>
        <section class={{
          'conversational-search-messages-suggestions-elements': true,
          'conversational-search-messages-suggestions-elements--banner-variant': props.isBannerVariant,
          'conversational-search-messages-suggestions-elements--banner-variant-no-hierarchy': props.isBannerVariant && !hierarchy,
          'conversational-search-messages-suggestions-elements--banner-variant-single': isSingleResult && props.isBannerVariant
        }}>
          {suggestions?.slice(0, 2).map((suggestion, index) => {
              return (
                <div class="conversational-search-messages-suggestions-elements-content">
                  {suggestions.length >= 2 && <div class="conversational-search-messages-suggestions-elements-content__divider" />}
                  <section class="conversational-search-messages-suggestions-elements-content-information">
                    <section data-index={index} class="conversational-search-messages-suggestions-elements-content-information__justification">
                      {suggestion?.justification ? <span>
                        <strong>{suggestion.productId} - </strong>
                        {suggestion?.justification}</span> : ''
                      }
                    </section>
                  </section>
                  <section class="conversational-search-messages-suggestions-elements-content__card">
                    <ConversationalSearchMessagesSuggestionsCard
                      data={suggestion}
                      query={query}
                      labelProvider={(e, f) => labelProvider(e, f)}
                      index={index}
                      isBannerVariant={isBannerVariant}
                      isMultipleSuggestions={!isSingleResult}
                      hasSingleCommStatusKey={hasSingleCommVisibleStatusKey} // Temporary logic
                      language={props.language}
                    />
                  </section>
                </div>
              );
          })}
        </section>
      </div>
    );
};
